import { useCallback, useContext } from 'react';
import { FirebaseAppContext } from 'libs.firebase_react';
import { AuthContext } from 'libs.react_internal';
import { ConsentScopeContext } from '../contexts/consent.context';
export function useConsentEventLogger() {
    const { logEvent, db } = useContext(FirebaseAppContext);
    const { entityId, user } = useContext(AuthContext);
    const { studyId } = useContext(ConsentScopeContext);
    const logConsentEvent = useCallback((eventKey, eventData = {}) => {
        if (db == null) {
            return;
        }
        logEvent(eventKey, {
            ...eventData,
            studyId,
            entityId,
            identityId: user?.id,
        });
    }, [db, entityId, logEvent, studyId, user?.id]);
    return { logConsentEvent };
}
